import { useEffect, useMemo, useState } from "react";
import templateCardStyles from "../Templates/TemplateCard/templateCard.module.scss";
import TemplateCard from "./TemplateCard";
import styles from "./templates.module.scss";
// import Button from "src/components/Button";
import { useQuery } from "@apollo/client";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import {
  ComputerIcon,
  MoreTemplates,
  PhoneIcon,
  PreviewEyeIcon,
  XclusiveIcon,
} from "src/components/Icons";
import StyledButton from "src/components/StyledButton.tsx";
import XclusiveFeaturesModal from "src/components/XclusiveFeaturesModal";
import { GetLuxeDetails } from "src/graphql/queries";
import { getRefreshToken } from "src/helper/storage";
import useAppStore from "src/store/utils";
import { DescribeLuxe } from "src/types/api";
import Iframe from "./Iframe";

type OrientationType = "portrait" | "landscape";

export interface TemplateType {
  id: string;
  name: string;
  image: string;
  // badge: string;
  // useCount: number;
  // likes: number;
  description: string;
  // previewCount: number;
}

const Templates = () => {
  const [orientation, setOrientation] = useState<OrientationType>("portrait");
  const { event } = useAppStore((state) => state);
  const refreshToken = getRefreshToken();

  const navigate = useNavigate();

  const [currency, setCurrency] = useState<string | undefined>("");
  const [discountedCost, setDiscountedCost] = useState<number | undefined>(0);
  const [undiscountedCost, setUnDiscountedCost] = useState<number | undefined>(
    0
  );

  const [isXclusiveFeaturesOpen, setIsXclusiveFeaturesOpen] = useState(false);

  useQuery<DescribeLuxe>(GetLuxeDetails, {
    variables: { event_id: event?.uuid },
    fetchPolicy: "network-only",
    // fetchPolicy: "cache-and-network",
    onCompleted(response) {
      setCurrency(response.describeLuxe.currency);
      setDiscountedCost(response.describeLuxe.discounted_amount);
      setUnDiscountedCost(response.describeLuxe.undiscounted_amount);
    },
    onError(error) {
      if (error?.message !== "unauthenticated") {
        toast.error(
          <p className="toast">{error?.message ?? "An error occured"}</p>
        );
      } else {
        navigate("/clear");
      }
    },
  });

  const templates = useMemo(
    () => [
      {
        id: "default",
        name: "Stellar",
        image: "/default-demo-image.png",
        // badge: "Luxe",
        // useCount: 0,
        // likes: 0,
        description: "A beautiful template for your wedding website",
        // previewCount: 0,
      },
      // {
      //   id: "eterna",
      //   name: "Eterna",
      //   image: "/eterna-demo-image.png",
      //   // badge: "Exclusive",
      //   // useCount: 2,
      //   // likes: 10,
      //   description: "A beautiful template for your wedding website",
      //   // previewCount: 0,
      // },
      {
        id: "lumen",
        name: "Lumen",
        image: "/lumen-demo-image.png",
        // badge: "Luxe",
        // useCount: 2,
        // likes: 5,
        description: "A beautiful template for your wedding website",
        // previewCount: 0,
      },
      {
        id: "lilac",
        name: "Lilac",
        image: "/lilac-demo-image.png",
        // badge: "Luxe",
        // useCount: 2,
        // likes: 5,
        description: "A beautiful template for your wedding website",
        // previewCount: 0,
      },
      {
        id: "blanc",
        name: "Blanc",
        image: "/blanc-demo-image.png",
        // badge: "Luxe",
        // useCount: 2,
        // likes: 5,
        description: "A beautiful template for your wedding website",
        // previewCount: 0,
      },
      {
        id: "funky",
        name: "Funky",
        image: "/funky-demo-image.png",
        // badge: "Luxe",
        // useCount: 2,
        // likes: 5,
        description: "A beautiful template for your wedding website",
        // previewCount: 0,
      },
      {
        id: "french",
        name: "French",
        image: "/french-demo-image.png",
        // badge: "Luxe",
        // useCount: 2,
        // likes: 5,
        description: "A beautiful template for your wedding website",
        // previewCount: 0,
      },
      {
        id: "fairy",
        name: "Fairy",
        image: "/fairy-demo-image.png",
        // badge: "Luxe",
        // useCount: 2,
        // likes: 5,
        description: "A beautiful template for your wedding website",
        // previewCount: 0,
      },
    ],
    []
  );

  const [activeTemplate, setActiveTemplate] = useState<TemplateType | null>(
    null
  );

  useEffect(() => {
    setActiveTemplate(
      templates.filter((template) => template.id === event.template_id)[0]
    );
  }, [event.template_id, templates]);

  // const listedTemplates =
  //   activeTemplate === templates[0]
  //     ? [templates[0]]
  //     : [templates[0], activeTemplate];

  return (
    <div className={styles["templates__container"]}>
      <p className="mb-8 px-[30px] text-sm font-semibold tracking-widest text-gray-400">
        YOUR TEMPLATE
      </p>
      <div className={styles["templates"]}>
        <div className={styles["templates__main"]}>
          <div className={styles["templates__main-content"]}>
            <div className={styles["templates__main-template"]}>
              {/* <div className={styles["templates__main-template-title"]}>
                <h5>Select Template</h5>
              </div> */}
              <div
                className={styles["templates__main-template-container"]}
                // onClick={() => {
                //   setClickedTemplate();
                // }}
              >
                <TemplateCard
                  key={activeTemplate?.id}
                  name={activeTemplate?.name}
                  // template={template}
                  image={activeTemplate?.image}
                />
                {/* {listedTemplates.map((template) => (
                ))} */}
              </div>

              <div className={styles["templates__main-template-container"]}>
                <Link
                  to={"/website/templates"}
                  className="rounded-lg hover:bg-3"
                >
                  <div
                    className={templateCardStyles["templateCard__container"]}
                  >
                    <div className="flex items-center gap-4">
                      <div className="flex h-[76px] w-[105px] cursor-pointer items-center justify-center rounded-lg border border-dashed border-[#A5ADAC]">
                        <MoreTemplates />
                      </div>
                      <p className="">
                        See more <br />{" "}
                        <span className="text-gray-500">Templates</span>
                      </p>
                    </div>
                  </div>
                </Link>
              </div>

              <div
                className="flex w-full cursor-pointer items-center gap-4 rounded-lg p-2 hover:bg-3"
                onClick={() => setIsXclusiveFeaturesOpen(true)}
              >
                <div className="flex h-20 w-20 items-center justify-center rounded-full border border-gray-400">
                  <XclusiveIcon />
                </div>
                <p className="">
                  I want my <br />{" "}
                  <span className="text-gray-500">own design</span>
                </p>
              </div>
              <XclusiveFeaturesModal
                isXclusiveFeaturesOpen={isXclusiveFeaturesOpen}
                setIsXclusiveFeaturesOpen={setIsXclusiveFeaturesOpen}
              />
            </div>

            <div className={`${styles["templates__main-preview"]} bg-1`}>
              {/* <div className={styles["templates__backdrop"]}>
                <LazyLoadImage
                  // src={Backdrop}
                  placeholderSrc={Backdrop}
                  alt="Backdrop"
                  effect="blur"
                  width="100%"
                  height="100%"
                  className={styles["templates__backdrop__image"]}
                />
              </div> */}

              <div className={styles["templates__main-preview__top"]}>
                <h2>{activeTemplate?.name}</h2>

                <div className={styles["templates__main-views"]}>
                  <div className={styles["templates__main-views-box"]}>
                    <div
                      className={`${orientation === "portrait" ? `border border-white` : ``} cursor-pointer rounded-md p-1`}
                      onClick={() => setOrientation("portrait")}
                    >
                      <span className="text-white">
                        <PhoneIcon />
                      </span>
                    </div>
                    <div
                      className={`${orientation === "landscape" ? `border border-white` : ``} cursor-pointer rounded-md p-1`}
                      onClick={() => setOrientation("landscape")}
                    >
                      <span className="text-white">
                        <ComputerIcon />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex gap-2 text-white">
                  {/* <StyledButton
                    variant="border-white"
                    className="h-8 w-16 rounded-md border"
                    onClick={openLuxeFeaturesModal}
                  >
                    Use
                  </StyledButton>

                  <LuxeFeaturesModal
                    isLuxeFeaturesOpen={isLuxeFeaturesOpen}
                    opened={isLuxeFeaturesOpen}
                    setIsLuxeFeaturesOpen={setIsLuxeFeaturesOpen}
                    currency={currency}
                    discountedCost={discountedCost}
                    undiscountedCost={undiscountedCost}
                    setOpenPaymentFlow={setOpenPaymentFlow}
                  /> */}

                  {/* <PaymentFlowModal
                    openPaymentFlow={openPaymentFlow}
                    setOpenPaymentFlow={setOpenPaymentFlow}
                  /> */}

                  <StyledButton
                    variant="border-white"
                    className="group flex h-8 w-16 items-center justify-center rounded-md border"
                  >
                    <a
                      target="_blank"
                      href={`https://${event.slug}.${process.env.REACT_APP_INAWO_WEDDING_SITE_END}?jelfo=og5xovf7i8f6ic678h_hk_8nl&evd=${refreshToken}&ppptf=ew2n498hdae3dd2h3a0gh24`}
                      rel="noreferrer"
                      className={styles["dashboardLayout__preview"]}
                    >
                      <div className="">
                        <PreviewEyeIcon />
                      </div>
                    </a>
                  </StyledButton>
                </div>
                {/* <div className={styles["templates__alert-save-button"]}>
                  <Button type="button" label="select template">
                    Select Template
                  </Button>
                </div> */}
              </div>

              <div className="flex w-full items-center justify-center">
                <Iframe
                  orientation={orientation}
                  src={`https://${event?.slug}.${process.env.REACT_APP_INAWO_WEDDING_SITE_END}/`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Templates;
